import React from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Link } from "react-router-dom";
import { FiSearch, FiMail, FiMenu, FiX } from "react-icons/fi";

function Header() {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    
    return (
        <header className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-b from-[#C8102E]/95 via-[#E31E3C]/95 to-[#A00D25]/95 backdrop-blur-xl shadow-2xl border-b border-white/30 shadow-[#C8102E]/20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-20">
                    {/* Logo Section */}
                    <div 
                        className="flex items-center gap-3 cursor-pointer group" 
                        onClick={() => navigate('/')}
                    >
                        <div className="relative">
                            {/* Glowing halo effect - luxurious gold */}
                            <div className="absolute inset-0 bg-gradient-to-r from-white/20 via-white/15 to-white/20 rounded-full blur-2xl opacity-50"></div>
                            <div className="absolute inset-0 bg-white/10 rounded-full blur-xl"></div>
                            <img 
                                src="/kidkat.png"
                                alt="KidKat"
                                className="relative z-10 w-20 h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 object-contain transition-transform group-hover:scale-110" 
                                style={{
                                    filter: 'brightness(1.2) contrast(1.3) drop-shadow(0 0 15px rgba(255, 255, 255, 0.5)) drop-shadow(0 0 25px rgba(255, 251, 235, 0.4)) drop-shadow(0 0 35px rgba(255, 255, 255, 0.3))'
                                }}
                            />
                            <div className="absolute inset-0 bg-white/20 rounded-full blur-xl opacity-0 group-hover:opacity-70 transition-opacity -z-0"></div>
                        </div>
                        <div>
                            <span className="text-white font-bold text-xl tracking-tight drop-shadow-lg">KidKat Games</span>
                            <div className="h-0.5 w-0 bg-gradient-to-r from-white via-white/80 to-white group-hover:w-full transition-all duration-300 shadow-lg shadow-white/50"></div>
                        </div>
                    </div>

                    {/* Desktop Navigation */}
                    <nav className="hidden lg:flex items-center gap-1">
                        <Link 
                            to="/" 
                            className="px-5 py-2.5 rounded-lg text-sm font-medium text-white hover:text-white/90 hover:bg-white/20 hover:shadow-lg hover:shadow-white/30 transition-all duration-200"
                        >
                            Home
                        </Link>
                        <Link 
                            to="/about" 
                            className="px-5 py-2.5 rounded-lg text-sm font-medium text-white hover:text-white/90 hover:bg-white/20 hover:shadow-lg hover:shadow-white/30 transition-all duration-200"
                        >
                            About
                        </Link>
                        <Link 
                            to="/contact" 
                            className="px-5 py-2.5 rounded-lg text-sm font-medium text-white hover:text-white/90 hover:bg-white/20 hover:shadow-lg hover:shadow-white/30 transition-all duration-200"
                        >
                            Contact
                        </Link>
                        <Link 
                            to="/privacy" 
                            className="px-5 py-2.5 rounded-lg text-sm font-medium text-white hover:text-white/90 hover:bg-white/20 hover:shadow-lg hover:shadow-white/30 transition-all duration-200"
                        >
                            Privacy
                        </Link>
                    </nav>

                    {/* Right Section - Search & Actions */}
                    <div className="flex items-center gap-3">
                        {/* Search Bar */}
                        <div className="hidden md:flex items-center bg-white/20 rounded-full px-4 py-2 border border-white/40 hover:border-white/60 hover:shadow-xl hover:shadow-white/30 transition-all backdrop-blur-sm">
                            <FiSearch className="text-white text-lg mr-2" />
                            <input 
                                placeholder="Search games..." 
                                className="bg-transparent outline-none text-sm text-white placeholder-white/70 w-32 focus:w-40 transition-all" 
                            />
                        </div>

                        {/* Contact Button */}
                        <button
                            onClick={() => navigate('/contact')}
                            className="hidden md:flex items-center gap-2 px-5 py-2.5 rounded-full bg-white hover:bg-white/90 text-[#C8102E] font-bold text-sm shadow-xl shadow-white/40 hover:shadow-2xl hover:shadow-white/60 transition-all hover:scale-105"
                        >
                            <FiMail className="text-base" />
                            <span>Contact</span>
                        </button>

                        {/* Mobile Menu Button */}
                        <button 
                            className="lg:hidden p-2 rounded-lg text-white hover:bg-white/20 hover:text-white/90 transition-colors" 
                            onClick={() => setOpen(v => !v)}
                            aria-label="Toggle menu"
                        >
                            {open ? <FiX className="w-6 h-6" /> : <FiMenu className="w-6 h-6" />}
                        </button>
                    </div>
                </div>

                {/* Mobile Navigation */}
                {open && (
                    <div className="lg:hidden pb-4 pt-2 border-t border-[#6b8e23]/20 animate-in slide-in-from-top">
                        <div className="flex flex-col gap-2 mt-2">
                            <Link 
                                to="/" 
                                onClick={() => setOpen(false)} 
                                className="px-4 py-3 rounded-lg text-white hover:text-white/90 hover:bg-white/20 hover:shadow-lg hover:shadow-white/30 transition-all font-medium"
                            >
                                Home
                            </Link>
                            <Link 
                                to="/about" 
                                onClick={() => setOpen(false)} 
                                className="px-4 py-3 rounded-lg text-white hover:text-white/90 hover:bg-white/20 hover:shadow-lg hover:shadow-white/30 transition-all font-medium"
                            >
                                About
                            </Link>
                            <Link 
                                to="/contact" 
                                onClick={() => setOpen(false)} 
                                className="px-4 py-3 rounded-lg text-white hover:text-white/90 hover:bg-white/20 hover:shadow-lg hover:shadow-white/30 transition-all font-medium"
                            >
                                Contact
                            </Link>
                            <Link 
                                to="/privacy" 
                                onClick={() => setOpen(false)} 
                                className="px-4 py-3 rounded-lg text-white hover:text-white/90 hover:bg-white/20 hover:shadow-lg hover:shadow-white/30 transition-all font-medium"
                            >
                                Privacy
                            </Link>
                            <div className="pt-2 mt-2 border-t border-[#6b8e23]/20">
                                <button
                                    onClick={() => {
                                        navigate('/contact');
                                        setOpen(false);
                                    }}
                                    className="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-white hover:bg-white/90 text-[#C8102E] font-bold shadow-xl shadow-white/40"
                                >
                                    <FiMail />
                                    <span>Contact Us</span>
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </header>
    );
}

export default Header;
